// extracted by mini-css-extract-plugin
export default {"dropdown":"MobileMenu_dropdown__lKC2P","dropdownBackground":"MobileMenu_dropdownBackground__lRa21","menuButton":"MobileMenu_menuButton__moOzB"};